import type { MarketingPermission } from "@redotech/redo-marketing-common/marketing-permissions";
import { hasMarketingPermission } from "@redotech/redo-marketing-common/marketing-permissions";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { RedoAdminMarketingRpcClientContext } from "../app/redo-admin-marketing-rpc-client-provider";

const NO_MARKETING_PERMISSIONS: MarketingPermission[] = [];

export function useCurrentMarketingPermissions(): MarketingPermission[] {
  const query = useRpcQuery(
    RedoAdminMarketingRpcClientContext,
    "getCurrentMarketingPermissions",
    {},
    { staleTime: 30_000 },
  );
  return query.data?.permissions ?? NO_MARKETING_PERMISSIONS;
}

export function useHasMarketingPermission(
  permission: MarketingPermission,
): boolean {
  return hasMarketingPermission(useCurrentMarketingPermissions(), permission);
}
